// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"357a8296","221":"dad1ff0e","599":"9ec491d1","625":"7a1dd94a","778":"3484d27d","806":"e6517615","868":"2a0b2582","879":"a1922441","910":"a2232cef","918":"454f3a01"}[chunkId] + ".chunk.js";
};